import { render } from "./index.vue?vue&type=template&id=cb93682a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cb93682a&lang=scss"
script.render = render

export default script